// Componentes base
import React from "react";
import { Link } from "react-router-dom";

// Barra superior
import Header from "../Header";

export default function Historia() {
    return (
        <div className="section">
            <Header />

            <div className="content">
                <div className="container">
                    <h3>A História do Priore</h3>

                    <p>Pra ser sincero com você, Priore nasceu de uma frustração, da minha frustração durante a graduação. Não foram poucas as vezes que busquei algum conteúdo ou ferramenta e me deparei com obstáculos. Apesar da diversidade deles, todos costumavam tangenciar um mesmo ponto: licença.</p>

                    <p>Artigos de revistas fechadas, que não foram compradas pela univeridade. Softwares pagos e com valor de assinatura alta, impossíveis para que eu tivesse acesso. Escassez de livros, textos ou materiais teóricos específicos sobre alguns assuntos. As vezes tive que me contentar com literatura do século passado...</p>

                    <p>Por isso eu decidi fazer diferente. Naquela época eu já me aproximava do mundo do Software Livre e criei uma meta: um dia eu juntaria tudo que eu consegui acumular e montaria uma plataforma, completamente livre para qualquer pessoa acessar.</p>

                    <p>O protótipo de Priore foi o meu TCC, onde apresentei um software para desktop com resolução numérica de problemas matemáticos, estatísticos e da engenharia. Além dos cálculos, também compilei um material teórico sobre diversos tópicos da engenharia.</p>

                    <p>Após um tempo, eu decidi aprimorar o projeto Priore. Este sistema que você agora acessa é o resultado da melhoria. Além dos cálculos da primeira versão, adicionei mais conteúdo sobre diversos temas e níveis.</p>

                    <p>Tudo aqui é livre e sempre será. É feito para a comunidade. E caso você deseje contribuir de alguma forma, doando materiais, textos, ilustrações ou qualquer coisa, sinta-se livre para entrar em contato. Só acessar o espaço adequado no menu principal ou clicar <Link to="/contato">aqui</Link>.</p>

                    <p>Ah, e para finalizar, preciso me apresentar. Eu me chamo Bruno, sou engenheiro químico e licenciado em química, além de me achar programador nas horas vagas. Bom, pelo menos algumas coisas eu consigo fazer com um bloco de notas e alguns comandos. Te encontro por ai, espero que aproveite Priore.</p>
                </div>
            </div>

        </div>
    );
}